/**
 * Hard end date for the launch price. When it passes, every countdown block
 * collapses gracefully instead of showing zeros.
 */
export const LAUNCH_DEADLINE = '2026-09-15T23:59:00-04:00';

/**
 * Rolling window, in hours, each visitor gets from their first visit.
 * The countdown starts at this many hours and never shows more than
 * the time left until LAUNCH_DEADLINE.
 */
export const LAUNCH_WINDOW_HOURS = 18;

export const CHECKOUT_URL = 'https://screen-adapt.impultienda.ar/checkout';
